var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage2StepBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0EFF0;}\r\n\t.st1{opacity:0.9;fill:url(#SVGID_1_);}\r\n\t.st2{opacity:0.6;fill:url(#SVGID_00000034088187074509330440000014361607334933946283_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 75,
    cy: 75,
    r: 75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.8845,
    y1: 79.2542,
    x2: 127.8367,
    y2: 79.2542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00408871,
    style: {
      stopColor: "#685197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    style: {
      stopColor: "#4990CA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89,108.9l33.5-33.5c7.1-7.1,7.1-18.7,0-25.8l0,0c-7.1-7.1-18.7-7.1-25.8,0L63.2,83.1 c-7.1,7.1-7.1,18.7,0,25.8l0,0C70.3,116,81.9,116,89,108.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044869169936983167200000005282853303791667110_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.0622,
    y1: 79.2542,
    x2: 94.0143,
    y2: 79.2542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00408871,
    style: {
      stopColor: "#685197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    style: {
      stopColor: "#4990CA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000044869169936983167200000005282853303791667110_)"
    },
    d: "M62.9,108.9L29.4,75.4 c-7.1-7.1-7.1-18.7,0-25.8l0,0c7.1-7.1,18.7-7.1,25.8,0l33.5,33.5c7.1,7.1,7.1,18.7,0,25.8l0,0C81.6,116,70,116,62.9,108.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage2StepBadge);
export default __webpack_public_path__ + "static/media/stage2-step_Badge.2ebea2f56c61be58d59d8290862aebe6.svg";
export { ForwardRef as ReactComponent };